import React from 'react';
import { ApIcon, colors } from '@alixpartners/ui-components';
import {
	Wrapper,
	Label,
	IconWrapper,
	CountWrapper,
	Circle,
} from './FilterRow.styles';

export const FilterRow = ({ searchQuery, label, count }) => {
	const getHighlightedName = name => {
		if (!searchQuery) {
			return name;
		}

		const index = name.toLowerCase().indexOf(searchQuery.toLowerCase());
		const before = name.slice(0, index);
		const searchValue = name.slice(index, index + searchQuery.length);
		const after = name.slice(index + searchQuery.length, name.length);

		return (
			<React.Fragment>
				{before}
				<span>{searchValue}</span>
				{after}
			</React.Fragment>
		);
	};

	return (
		<Wrapper>
			<CountWrapper>{!!count && <Circle>{count}</Circle>}</CountWrapper>
			<Label>{getHighlightedName(label)}</Label>
			<IconWrapper>
				<ApIcon
					iconName="chevron_left"
					iconColor={colors.grey7}
					iconSize={16}
				/>
			</IconWrapper>
		</Wrapper>
	);
};
